module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    staticClass: "modal-background-connected",
    attrs: {
      "padding": "0px",
      "borderRadius": "11px",
      "width": '598px',
      "height": '452px'
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "top-container start-xs ml3"
  }, [_c('pl-button', {
    staticClass: "pl-primary-font",
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left pr2"
  }), _vm._v(" "), _c('span', {
    staticClass: "f5"
  }, [_vm._v("Back")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-nowrap flex-grow items-center justify-center body-container"
  }, [_c('div', {
    staticClass: "f6 fw6 center-xs mt5 ph4 text-content"
  }, [_vm._v("\n      You can only connect the RoundTable to one LMS assignment at a time.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "mt4 center-xs"
  }, [_c('img', {
    attrs: {
      "src": _vm.integration_connected.provider_icon_url,
      "height": "60px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('div', {
    staticClass: "row no-margin button-row center-xs"
  }, [_c('pl-button', {
    staticClass: "pl-ruby fw6",
    nativeOn: {
      "click": function($event) {
        return _vm.disconnectIntegration.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        DISCONNECT\n      ")])], 1)]), _vm._v(" "), (_vm.show_disconnect_integration_modal) ? _c('disconnect-assignment-modal', {
    attrs: {
      "integrationToDisconnect": _vm.integration_connected
    },
    on: {
      "close": function($event) {
        _vm.show_disconnect_integration_modal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4e7acc1c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/shareActivityModalViews/integrationConnectedModal.vue
// module id = 1255
// module chunks = 61